<div class="rich-text-editor">
  <div #editorContainer [style.height]="height"></div>
</div>
